<div class="covered-call-rebalance-settings">
  <div class="flex-row">
    <div class="flex-column flex-column-header"
      [class]="{'sell-cover-flex-column-header': viewMode === 'SELL_COVER_CALL'}"><strong>Trade Type</strong></div>
      <div class="flex-column">
        @if (coveredCallTradeTypes) {
          <irb-dropdown-filter #IrbDropdownFilterOff
            id="tradeTypeDropdown"
            [value]="defaultCoveredCallTradeType"
            [disabled]="isReadOnly"
            [size]="30"
            (search)="setChainTypeOptions($event)"
            (selection)="selectOption($event)"
          ></irb-dropdown-filter>
        }
      </div>
    </div>
    <div class="flex-row">
      <div class="flex-column flex-column-header"
        [class]="{'sell-cover-flex-column-header': viewMode === 'SELL_COVER_CALL'}">
        <strong>Allow in:</strong>
      </div>
      <div class="flex-column">
        <div class="checkboxes-horizontal-align">
          <div class="flex-checkbox-item">
            <p-checkbox name="isTaxable" [(ngModel)]="data.isTaxable" binary="true"
              (onChange)="onAllowInModified();" [disabled]="isReadOnly"
              inputId="coveredcallitem1">
            </p-checkbox>
            <label for="coveredcallitem1">Taxable accounts</label>
          </div>
          <div class="flex-checkbox-item">
            <p-checkbox name="isQualified" [(ngModel)]="data.isQualified"
              binary="true" (onChange)="onAllowInModified();" [disabled]="isReadOnly"
              inputId="coveredcallitem2">
            </p-checkbox>
            <label for="coveredcallitem2">Qualified accounts</label>
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (viewMode === 'SELL_COVER_CALL' && !isUiTest) {
    <sell-coveredcall-settings [(data)]="data"
    (change)="onOptionSettingsModified();" [isReadOnly]="isReadOnly"></sell-coveredcall-settings>
  }
  @if (viewMode === 'BUY_TO_COVER' && !isUiTest) {
    <buy-to-cover-settings [(data)]="data"
    (change)="onOptionSettingsModified();" [isReadOnly]="isReadOnly"></buy-to-cover-settings>
  }
  @if (viewMode === 'PURCHASE_UNDERLYING_SELL_COVER_CALL' && !isUiTest) {
    <purchase-underlying-settings
    [(data)]="data" (change)="onOptionSettingsModified();" [isReadOnly]="isReadOnly"></purchase-underlying-settings>
  }
  @if (viewMode === 'ROLL_COVER_CALL' && !isUiTest) {
    <roll-coveredcall-settings [(data)]="data"
    (change)="onOptionSettingsModified();" [isReadOnly]="isReadOnly"></roll-coveredcall-settings>
  }
